exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table td {\n  vertical-align: middle !important;\n}\ntable tr:hover td {\n  background-color: inherit;\n  opacity: 1;\n  border-radius: 7px;\n}\n.borderRight {\n  border-right: solid 2px white;\n}\n#dietTable {\n  margin-bottom: 0;\n}\n#firstStep {\n  align-items: center;\n}\n.customSection {\n  padding: 1.3rem !important;\n  border-top: 1px solid #dbdbdb;\n  border-bottom: 1px solid #dbdbdb;\n  background-color: white;\n}\n.field-label-30 {\n  flex: 0 0 30%;\n  text-align: center;\n}\n.scrollableTableWrapper {\n  overflow-y: auto;\n  height: 216px;\n}\n.scrollableTableWrapper td a {\n  display: block;\n  width: 100%;\n}\n", ""]);

// exports
